// extracted by mini-css-extract-plugin
export default {"container":"fL-z","topReviewHeading":"gL-z","criticalReview":"hL-z","favorableReview":"iL-z","vsSeparator":"jL-z"};